module.exports = __webpack_public_path__ + "images/dingtalk/ad20160530/2-613714117b6d67087161601d928bc50c.png";